import { FC } from 'react'
import { TooltipProps } from 'recharts'
import theme from 'theme'
import { formatWeekRange } from '../../categoryDashboard.utils'

const tooltipStyle: React.CSSProperties = {
  background: theme.colors.surfaceContainerBackground,
  border: 'none',
  borderRadius: '12px',
  padding: '16px',
  boxShadow: theme.colors.legacyChartTooltipShadow,
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  whiteSpace: 'nowrap'
}

const dateStyle: React.CSSProperties = {
  fontFamily: theme.typography.fontFamily.primary,
  fontWeight: 600,
  fontSize: 14,
  lineHeight: '20px',
  color: theme.colors.menuItemText
}

const rowStyle: React.CSSProperties = {
  display: 'flex',
  gap: '8px',
  fontFamily: theme.typography.fontFamily.primary,
  fontWeight: 500,
  fontSize: 12,
  lineHeight: '16px',
  color: theme.colors.devicesSecondaryText
}

const PerformanceChartTooltip: FC<TooltipProps<any, any>> = ({ active, payload, label }) => {
  if (!active) return null

  // The hidden `tooltipAnchor` Line guarantees a payload at every x position.
  // The `value` entry is dropped by recharts when its value is null, so its
  // absence is the signal for "No data".
  const valueEntry = payload?.find((p: any) => p.dataKey === 'value')
  const anchorEntry = payload?.find((p: any) => p.dataKey === 'tooltipAnchor')
  const fullDate = valueEntry?.payload?.fullDate ?? anchorEntry?.payload?.fullDate ?? label
  if (!fullDate) return null

  const value = valueEntry?.value
  const formattedDate = formatWeekRange(fullDate)
  const hasData = value != null

  return (
    <div style={tooltipStyle}>
      <div style={dateStyle}>{formattedDate}</div>
      <div style={rowStyle}>
        {hasData ? (
          <>
            <span>Performance Score:</span>
            <span>{`${Number(value.toFixed(1))}%`}</span>
          </>
        ) : (
          <span>No data</span>
        )}
      </div>
    </div>
  )
}

export default PerformanceChartTooltip
